import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const DefaultMealIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 45 45" {...props}>
      <rect width="45" height="45" rx="22.5" fill="#F5F7FA" />
      <path
        d="M36.6631 28.2152C36.5553 28.043 36.3667 27.9375 36.1639 27.9375H9.21083C9.00808 27.9375 8.81944 28.043 8.71277 28.2152C8.60614 28.3875 8.5956 28.6031 8.687 28.7848C9.50966 30.4312 11.1632 31.4531 13.003 31.4531H32.3717C34.2104 31.4531 35.8639 30.4312 36.6889 28.7859C36.778 28.6031 36.7698 28.3887 36.6631 28.2152Z"
        fill={colors.gray}
      />
      <path
        d="M24.2949 16.3406C24.391 16.1238 24.4461 15.8847 24.4461 15.6328C24.4461 14.6637 23.6574 13.875 22.6883 13.875C21.7191 13.875 20.9305 14.6637 20.9305 15.6328C20.9305 15.8848 20.9856 16.1238 21.0816 16.3406C15.7719 17.0707 11.5789 21.3457 11.041 26.7656H34.3344C33.7965 21.3481 29.6024 17.0707 24.2949 16.3406ZM22.141 19.7332C18.8633 19.95 16.0402 22.0898 14.9515 25.1848C14.8672 25.425 14.6398 25.5762 14.3984 25.5762C14.334 25.5762 14.2684 25.5656 14.2039 25.5434C13.8992 25.4355 13.7387 25.1015 13.8453 24.7957C15.0899 21.2566 18.3161 18.8109 22.0637 18.5636C22.3742 18.5437 22.6649 18.7863 22.6871 19.1097C22.7082 19.4332 22.4644 19.7121 22.141 19.7332Z"
        fill={colors.gray}
      />
    </SvgIcon>
  );
};

export default DefaultMealIcon;
